export const environment = {
  production: false,
  baseUrl: 'https://braidsbook.cleverapps.io',
  apiUrl: 'https://braidsbook.cleverapps.io/api',
  placesApi: 'AIzaSyCMVu9q6pgpulb6xz6K1CsEj82smL2AEeo',
  recaptchaSiteKey: '6Ldh4FMrAAAAAF6vyYzJHSCwowZX69kE_T9IE781',
};
